import { DecimalService } from '@mews-framework/services';
import { UnicodeEntity } from '@mews/enums';
import { FormInputField, FormInputFieldProps } from './FormInputField';

const MAX_DIGIT_LENGTH = 15;
const DISABLED_KEYS = ['e', 'E', '+'];
const DECIMAL_HUNDRED = DecimalService.parse(100);

export type FormPercentageInputFieldProps = Omit<FormInputFieldProps, 'step' | 'suffix' | 'transform' | 'type'>;

/**
 * FormPercentageInputField is a component that allows the user to input a percentage value.
 * The value is stored as a number between 0 and 1.
 */
export const FormPercentageInputField = (props: FormPercentageInputFieldProps) => (
    <FormInputField
        {...props}
        type="number"
        suffix={UnicodeEntity.Percent}
        transform={{
            input: (userInput) => {
                const value = userInput as string;
                if (value === '') {
                    return null;
                }
                const decimalValue = DecimalService.divide(
                    DecimalService.parse(value.slice(0, MAX_DIGIT_LENGTH)),
                    DECIMAL_HUNDRED
                );
                return DecimalService.toNumber(decimalValue);
            },
            output: (storedValue) => {
                if (storedValue === null) {
                    return '';
                }
                const decimalValue = DecimalService.multiply(
                    DecimalService.parse(storedValue as number),
                    DECIMAL_HUNDRED
                );
                return DecimalService.toString(decimalValue);
            },
        }}
        step={1}
        onKeyDown={(event) => {
            if (DISABLED_KEYS.includes(event.key)) {
                event.preventDefault();
            }
            props.onKeyDown?.(event);
        }}
    />
);
